import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`
export const EditBtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 -40px 0;
`
export const BtnContainer = styled.div`
  display: flex;
  gap: 16px;
`

export const Title = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
`
export const Subtitle = styled.p`
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.primary};
`

export const Container = styled.div`
  margin-top: 20px;
  padding: 30px;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.background};
`
export const ActivityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  max-width: 500px;
`
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid ${({ theme }) => theme.colors.backgroundLite};

  &:last-child {
    border: none;
    padding: 10px 0 0 0;
  }
`
export const RowHeader = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`
export const Text = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
`
